const translations = {
    categories: 'Categories',
    editLabel: 'Edit the {{stateOfCertification}} certification',
    expirationDate: 'Expires',
    expired: 'Expired {{expirationDate}}',
    expiresInDay: 'Expires in 1 day',
    expiresInDays: 'Expires in {{dayCount}} days',
    expiresToday: 'Expires today',
    issuedDate: 'Issued',
    lastUpdated: 'Last updated {{updatedAt}}',
    licenseNumber: 'License no.',
    valid: 'Valid',
    validThrough: 'Valid through {{expirationDate}}'
};

export default translations;
